import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import useScrollIntoView from '../hooks/useScrollIntoView';
import { Link } from 'react-router-dom';
import '../styles/styles.css';

function Main() {

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  //Scrolls the elements into view
  useScrollIntoView();

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission
    const form = event.target;

    // Apply form validation
    if (!form.checkValidity()) {
      event.stopPropagation();
      form.classList.add('was-validated');
      return; // Stop submission if form is invalid
    }

    form.classList.add('was-validated');

    // Prepare email data from form
    const formData = {
      from_name: form.from_name.value,
      from_email: form.from_email.value,
      message: form.message.value,
      reply_to: form.from_email.value, // Add this line to set reply-to
    };

    emailjs.send('service_fz0m9bd', 'template_fwfktdc', formData, '2T__PCDWqEFKK9kLd')
      .then(() => {
        setSuccessMessage('Message sent successfully!');
        setErrorMessage('');
        form.reset(); // Reset the form after successful submission
        form.classList.remove('was-validated'); // Remove validation state after reset
      })
      .catch(() => {
        setErrorMessage('Failed to send message. Please try again.');
        setSuccessMessage('');
      });
};

  return (
      
    <main className="d-flex flex-column" id="home">
      <header className="webDev d-flex flex-column justify-content-center align-items-center">
        <h1 className="fw-bold text-center display-1" id="home">WEB DEVELOPER</h1>
        <a href="#projects" id="myProjects" className="text-white fw-bold appearOnScroll text-center mx-auto">
          MY PROJECTS
        </a>
      </header>

      <section className="techStack">
        <h2 className="fw-bold mb-5 text-center display-3">TECH STACK</h2>
        <ul className="techStackList text-center appearOnScroll d-flex justify-content-center">
          <li name="javascript" className="projects fw-bold">JAVASCRIPT</li>
          <li name="java" className="projects fw-bold">JAVA</li>
          <li name="php" className="projects fw-bold">PHP</li>
          <li name="html" className="projects fw-bold">HTML</li>
          <li name="css" className="projects fw-bold">CSS</li>
          <li name="bootstrap" className="projects fw-bold">BOOTSTRAP</li>
          <li name="git" className="projects fw-bold">GIT</li>
          <li name="nodejs" className="projects fw-bold">NODE.JS</li>
          <li name="react" className="projects fw-bold">REACT</li>
          <li name="sql" className="projects fw-bold">SQL</li>
        </ul>
      </section>

      <section id="projects">
        <h2 className="fw-bold mb-5 text-center display-3">PROJECTS</h2>
        <div className="appearOnScroll d-flex flex-column flex-md-row justify-content-center">
          <article className="card mb-3 p-3">
            <h3 className="card-header text-center">INDIE PROJECT</h3>
            <div className="card-body">
              <p>A CRUD application that revolves around race results.</p>
              <p className="fw-bold">JAVA JAVASCRIPT HTML CSS SQL</p>
              <span class="d-flex justify-content-center">
                <Link to="https://github.com/JBostroem96/indieProject" target="_blank" rel="noreferrer" className="view fw-bold text-white">VIEW</Link>
              </span>
            </div>
          </article>

          <article className="card mb-3 p-3">
            <h3 className="card-header text-center">CHICKEN SANDWICH RANKER</h3>
            <div className="card-body">
              <p>A CRUD application for chicken sandwich rankings.</p>
              <p className="fw-bold">PHP/Laravel TAILWIND HTML</p>
              <span class="d-flex justify-content-center">
                <Link to="https://github.com/JBostroem96/Chicken-Sandwich-Ranker-PHP-Laravel-" target="_blank" rel="noreferrer" className="view fw-bold text-white">VIEW</Link>
              </span>
            </div>
          </article>
        </div>
      </section>

      <section className="d-flex flex-column" id="contact">
        <h2 className="fw-bold text-center mb-3 display-3">CONTACT</h2>
                
        {successMessage && <div className="alert alert-success">{successMessage}</div>}
        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

        <form className="appearOnScroll needs-validation mx-auto w-100" onSubmit={handleSubmit} noValidate>
          <div className="form-group mb-3">
            <label className="fw-bold mb-2" htmlFor="from_name">NAME:</label>
            <input type="text" className="form-control" name="from_name" id="from_name" pattern="[a-zA-Z\s]{1,30}" required />
            <div className="valid-feedback">Looks good!</div>
              <div className="invalid-feedback">Please enter a name with max 30 characters</div>
          </div>

          <div className="form-group mb-3">
            <label className="fw-bold mb-2" htmlFor="email">EMAIL:</label>
            <input type="email" className="form-control" name="from_email" id="email" required />
            <div className="valid-feedback">Looks good!</div>
              <div className="invalid-feedback">Please enter a valid email</div>
          </div>

          <div className="form-group mb-3">
            <label className="fw-bold mb-2" htmlFor="message">MESSAGE:</label>
            <textarea className="col-10 form-control" name="message" id="message" rows="10" minLength="30" required></textarea>
            <div className="valid-feedback">Looks good!</div>
              <div className="invalid-feedback">Message must be at least 30 characters</div>
          </div>

          <div className="button text-center"> 
            <button type="submit" className="form-btn fw-bold mt-3 mb-5">SUBMIT</button>
          </div>
        </form>
      </section> 
    </main>
  );
}

export default Main;